class ProductAddedPopup extends HTMLElement {
  constructor() {
    super();
    this.openTrigger = document.querySelector('.drawer__icon');
    this.closeTrigger = document.querySelector('#drawer-close');
    this.inner = document.querySelector('#drawer-inner');
    this.altCloseTrigger = document.querySelector('.drawer-close-icon');
    this.parent = ProductAddedPopup.getParent();
    this.handleScrollBind = this.handleScroll.bind(this);
    
    document.addEventListener('DOMContentLoaded', _ => {
      this.greyBar = document.querySelector('.full-width.ir-grey-bg');
      this.header = document.querySelector('.header-wrapper');
    });

    window.addEventListener('scroll', this.handleScrollBind);
  }

  static getParent() {
    return document.getElementById('shopify-section-product-added-popup');
  }

  handleScroll() {
    let distance = document.querySelector('html').scrollTop;
    let barHeight = this.greyBar.clientHeight;
    let headerHeight = this.header.clientHeight;
    let html = document.querySelector('html');

    if(!this.parent.classList.contains('overlay')) {
      return;
    }
    
    if(distance > 0) {
      let totalHeight = barHeight + headerHeight;
      this.parent.style.position = "fixed";

      if(distance < totalHeight) {
        // this.parent.style.top = totalHeight - html.scrollTop + 'px';
        this.parent.style.marginTop = barHeight + headerHeight - distance + 'px';
        this.parent.style.top = 0;
        // document.querySelector('product-added-popup').style.marginTop = (barHeight + headerHeight - distance) * -1 + 'px';
        // if(window.innerWidth < 700) {
          if(distance < barHeight) {
            document.querySelector('#shopify-section-product-added-popup').style.marginTop = (barHeight - distance + headerHeight + 1) + 'px';
          }
          else {
            document.querySelector('#shopify-section-product-added-popup').style.marginTop = (headerHeight + 1) + 'px';
          }
          // document.querySelector('product-added-popup').style.marginBottom = (totalHeight - html.scrollTop) + 'px';
        // }
      } else {
        this.parent.style.top = 0;
        this.parent.style.marginTop = 0;
        // if(window.innerWidth < 700) {
          document.querySelector('#shopify-section-product-added-popup').style.marginTop = (headerHeight + 1) + 'px';
          document.querySelector('product-added-popup').style.marginBottom = 0;
        // }
      }
    } else {
      this.parent.style.position = "fixed";
      let totalHeight = barHeight + headerHeight;
      this.parent.style.marginTop = (totalHeight - html.scrollTop) + 'px';
      // document.querySelector('product-added-popup').style.marginTop = (totalHeight) * -1 + 'px';
      // if(window.innerWidth < 700) {
        document.querySelector('#shopify-section-product-added-popup').style.marginTop = (barHeight + headerHeight + 1) + 'px';
        // document.querySelector('product-added-popup').style.marginBottom = (totalHeight - html.scrollTop) + 'px';
      // }
    }
  }
  
  connectedCallback() {
    // this.openTrigger.addEventListener('click', this.open.bind(this));
//     this.closeTrigger.addEventListener('click', this.close.bind(this));
    // this.altCloseTrigger.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.parent.style.height = "100%";
    this.parent.classList.add('overlay');
    document.querySelector('product-added-popup').style.display = 'block';
    this.handleScroll();
  }
  
  static s_open() {
    document.querySelector('cart-drawer').style.right = '0';
  }

  static close() {
    if(window.innerWidth > 700) {
      document.querySelector('product-added-popup').classList.add('closing');
    } else {
      document.querySelector('product-added-popup').classList.add('closing-mobile');
    }
    window.setTimeout(_ => {
      ProductAddedPopup.getParent().classList.remove('overlay');
      document.querySelector('product-added-popup').style.display = 'none';
      ProductAddedPopup.getParent().style.position = "fixed";
      ProductAddedPopup.getParent().style.height = 0;
      document.querySelector('product-added-popup').classList.remove('closing');
      document.querySelector('product-added-popup').classList.remove('closing-mobile');
    }, 400);
  }
  
  static sRenderOpen(data) {
    var parser = new DOMParser();
	  var doc = parser.parseFromString(data, "text/html")
	  var new_data = doc.getElementById('drawer-inner').innerHTML;
    document.querySelector('#drawer-inner').innerHTML = new_data;
    CartDrawer.s_open();
  }

  renderImage(data) {
    let img = document.querySelector("#popup-image");
    img.innerHTML = `<img src='${data}'/>`;
  }

  renderRecommendedImage(data) {
    let img = document.querySelector("#popup-image.recommended-image");
    img.innerHTML = `<img src='${data}'/>`;
  }

  renderTitle(title) {
    document.querySelector('#item-added .drawer-product-title').innerHTML = title;
  }

  renderRecommendedTitle(title) {
    document.querySelector('#item-added .recommended .drawer-product-title').innerHTML = title;
  }
  
  renderOpen(data) {
    if(data.image) {
      this.renderImage(data.image);
    }

    let itemTitle = data.product_title.replace(" - ", "").replace("Motorcycle", "").replace("Boots", "").replace("Gloves", "");
    this.renderTitle(itemTitle);

    document.querySelector('#item-added .drawer-main-collection-title').innerHTML = data.product_type;

    if(data.variant_title) {
      document.querySelector('#item-added .drawer-variant-title').innerHTML = data.variant_title;
    }

    document.querySelector('#popup-image-link').href = data.url;

    this.open();
  }

  renderRecommendedCollection(collection) {
    document.querySelector('#item-added .recommended .drawer-main-collection-title').innerHTML = collection;
  }

  renderRecommended(item) {
    if(item.image) {
      this.renderRecommendedImage(item.image);
      this.renderRecommendedTitle(item.title);
      this.renderRecommendedCollection(item.collection);
      document.querySelector('#popup-image-link-recommended').href = item.url;
      document.querySelector('.recommended .product-title-link').href = item.url;
    }
  }

  recommendedToggle() {
    document.querySelector('product-added-popup .recommended').style.display = 'block';
  }
  
  renderContents(parsedState, recommended = null) {
    if(recommended != null) {
      this.recommendedToggle();
      this.renderRecommended(recommended);
    }
    this.renderOpen(parsedState);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

}

customElements.define('product-added-popup', ProductAddedPopup);
